import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title, Span } from '../../components/Shared/TitleSuccess';
import { copyFor } from '../../copy/copy';

const TitleComponent = props => (
    <Title>
        {props.useLocalRepresentative ? (
            <Span>
                {copyFor('feedback', 'sent', 'petition', undefined, {
                    recipientName: 'Rep ' + props.repFullName
                })}
            </Span>
        ) : (
            <Span>{copyFor('feedback', 'signed', 'petition')}</Span>
        )}
    </Title>
);

TitleComponent.propTypes = {
    useLocalRepresentative: PropTypes.bool,
    repFullName: PropTypes.string
};

const PetitionAction = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            rightAlign
            thankYouText={props.thankYouText}
            thankYouTitle={props.thankYouTitle}
            peopleCount={props.peopleCount}
            useLocalRepresentative={props.useLocalRepresentative}
            titleComponent={
                <TitleComponent
                    useLocalRepresentative={props.useLocalRepresentative}
                    repFullName={props.repFullName}
                />
            }
            {...props}
        />
    </TransitionContainerNoExit>
);

PetitionAction.propTypes = {
    thankYouText: PropTypes.string.isRequired,
    thankYouTitle: PropTypes.string,
    peopleCount: PropTypes.string.isRequired,
    useLocalRepresentative: PropTypes.bool,
    repFullName: PropTypes.string
};

export default connect(
    state => ({
        repFullName: state.localRep.localRepData.representative
            ? state.localRep.localRepData.representative[0].fullName
            : '',
        thankYouText: state.petition.successInfo.thankYouText || '',
        thankYouTitle: state.petition.successInfo.thankYouTitle,
        peopleCount:
            state.petition.completePetition !== undefined
                ? state.petition.completePetition.endUsersCount
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : '',
        useLocalRepresentative: state.petition.successInfo.useLocalRepresentative
    }),
    {}
)(PetitionAction);



// WEBPACK FOOTER //
// ./src/containers/Petition/PetitionSuccess.jsx